import { useAppDispatch, useAppSelector } from '../../../../redux/hook'
import { Formik, FormikHelpers } from 'formik'
import { forgot } from '../../api'
import { SHOW_NOTIFICATION } from '../../../../redux/slices/showNotificationSlice'
import { Button, InputField } from '../../../../components'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'
import { ForgotSchema } from '../../schema'
import { ForgotFormPropsType, ForgotFormValues } from '../../type'
import { useTranslation } from 'react-i18next'
import { User } from '../../slice/userSlice'

const ForgotForm = ({ onSuccess }: ForgotFormPropsType) => {
    const dispatch = useAppDispatch()
    const state = useAppSelector((state) => state.persistedReducers.user)
    const { t } = useTranslation()
    const handleForgot = async (
        values: ForgotFormValues,
        actions: FormikHelpers<ForgotFormValues>
    ) => {
        const form = {
            email: values.email,
        }
        dispatch(SHOW_LOADER())
        try {
            const forgotResponse = await forgot(form)
            if (forgotResponse) {
                const response = forgotResponse?.data
                dispatch(
                    SHOW_NOTIFICATION({
                        message: response,
                        type: 'success',
                    })
                )
                dispatch(HIDE_LOADER())
                dispatch(
                    User({
                        ...state,
                        email: values.email, // Update the email field with the new value
                    })
                )
                onSuccess(true)
            }
            actions.setSubmitting(false)
        } catch (error: any) {
            if (error?.response?.status === 500) {
                dispatch(
                    SHOW_NOTIFICATION({
                        message: 'Invalid User',
                        type: 'error',
                    })
                )
            }
        }
    }
    return (
        <div className="auth-form">
            <Formik
                initialValues={{ email: '' }}
                validationSchema={ForgotSchema}
                onSubmit={handleForgot}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                }) => (
                    <form onSubmit={handleSubmit}>
                        <InputField
                            type="email"
                            name="email"
                            lable={t('lable.email')}
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.email}
                            touched={touched.email}
                        />
                        <div>
                            <Button type="submit" disabled={isSubmitting}>
                                {t('button.submit')}
                            </Button>
                        </div>
                    </form>
                )}
            </Formik>
        </div>
    )
}
export default ForgotForm
